<template>
  <div>
    <el-card v-loading="loading" style="min-height: 100px" shadow="hover">
      <div v-if="editModel" style="padding: 20px">
        <el-form
          ref="form"
          :size="$xUISize"
          :model="editModel"
          :rules="editRules"
          @submit.native.prevent
          label-width="auto"
          label-position="top"
        >
          <el-form-item label="账户昵称" prop="nickname">
            <el-input
              placeholder="请输入账户昵称"
              v-model="editModel.nickname"
              maxlength="18"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="editSubmit"
              @submit.native.prevent
              @click="submitClick"
            >
              保存
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-empty
        v-else-if="!loading"
        :description="errorMsg || '正在加载内容'"
        :image-size="100"
      >
        <el-button v-if="errorMsg" @click="fetchModel" size="small">
          重新加载
        </el-button>
      </el-empty>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params,
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query,
      );
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      editSubmit: false,
      editModel: null,
      editRules: {
        nickname: [
          {
            required: true,
            message: '请输入账户昵称',
            trigger: 'change',
          },
        ],
      },
    };
  },
  methods: {
    submitClick() {
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          const method = 'biz.customer.account.auth.editProfile';
          this.requestApi(method, this.editModel, {
            showError: true
          }).then((resp) => {
            this.success('保存成功');
            this.commitState({ userProfile: resp.data });
            this.$drawer.refreshDrawer();
            this.$drawer.backDrawer();
          }).finally(() => {
            this.editSubmit = false;
          });
        } else {
          this.showValidate(data);
        }
      });
    },
    handleModel() {
      // nothing
    },
    fetchModel() {
      // 编辑
      this.loading = true;
      this.errorMsg = null;
      this.editModel = null;
      return this.requestApi('biz.customer.account.auth.profile').then((resp) => {
        this.editModel = resp.data;
        this.handleModel();
      }).catch((err) => {
        this.errorMsg = (err && err.msg) || (err && err.message) || '连接服务器失败，请检查网络';
      }).finally(() => {
        this.loading = false;
      });
    },
  },
  mounted() {
    this.fetchModel();
  },
};
</script>
